import { Component } from '@angular/core';
import { RidButton } from '../../../../components/rid-button/rid-button';
import { RidDemoPage } from '../../../../components/rid-demo-page/rid-demo-page';

@Component({
  selector: 'app-yes-no-page',
  imports: [RidDemoPage, RidButton],
  templateUrl: './yes-no-page.html',
})
export class YesNoPage {}
